import { AfterViewInit, Component, forwardRef, Injector, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';

export interface RadioBtn {
  label: string;
  value: string;
}

@Component({
  selector: 'app-radiobuttons',
  templateUrl: './radiobuttons.component.html',
  styleUrls: ['./radiobuttons.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadiobuttonsComponent,
      multi: true
    }
  ],
})
export class RadiobuttonsComponent implements ControlValueAccessor {
  @Input() radiobuttons: RadioBtn[] = [];
  private control?: AbstractControl | null;
  value?: string;
  disabled: boolean = false;

  constructor(private injector: Injector) {
  }
  
  onBtnChange(event: any): void {
  }

  onChange = (value: number) => {};

  onTouched = () => {};

  writeValue(value: string) {
    this.value = value;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }


}
